import { render, staticRenderFns } from "./KpiBudgetSubTable.vue?vue&type=template&id=2b20f37e&"
import script from "./KpiBudgetSubTable.vue?vue&type=script&lang=js&"
export * from "./KpiBudgetSubTable.vue?vue&type=script&lang=js&"
import style0 from "./KpiBudgetSubTable.vue?vue&type=style&index=0&id=2b20f37e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QMarkupTable} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QMarkupTable})
